import { Stack } from '@bedrock-layout/stack';
import styled from 'styled-components';

export const WorkflowContainer = styled(Stack)`
  min-block-size: 20rem;
  overflow-y: auto;
`;
